import React from 'react';

function RoundTrip() {
  const flightData = [
    {
      airline: 'IndiGo',
      from: 'Delhi',
      to: 'Bali',
      seats: 20,
      cost: '₹18,500',
      month: 'December',
      onwarddate: '22 Dec 2025',
      returndate: '22 Dec 2025'
    },
    {
      airline: 'AirAsia',
      from: 'Mumbai',
      to: 'Singapore',
      seats: 15,
      cost: '₹14,200',
      month: 'January',
      onwarddate: '22 Dec 2025',
      returndate: '22 Dec 2025'
    }
  ];

  return (
    <div className="p-4 md:p-6 mt-10">
      {/* Search Section */}
      <div className="bg-gray-800 text-white rounded-md p-4 md:p-6 flex flex-col md:flex-row md:items-end gap-4">
        <div className="flex flex-col w-full md:w-40">
          <label className="mb-1">From</label>
          <input
            type="text"
            className="p-2 rounded text-black w-full"
            placeholder="Delhi"
          />
        </div>

        <div className="text-2xl text-center hidden md:block">⇄</div>

        <div className="flex flex-col w-full md:w-40">
          <label className="mb-1">To</label>
          <input
            type="text"
            className="p-2 rounded text-black w-full"
            placeholder="Bali"
          />
        </div>

        <div className="flex flex-col w-full md:w-48">
          <label className="mb-1">Depart On</label>
          <input type="date" className="p-2 rounded text-black w-full" />
        </div>

        <div className="flex flex-col w-full md:w-40">
          <label className="mb-1">Travelers</label>
          <select className="p-2 rounded text-black w-full">
            <option>1 Adult</option>
            <option>2 Adults</option>
            <option>3 Adults</option>
          </select>
        </div>

        <button className="bg-blue-600 w-full md:w-auto px-6 py-2 rounded text-center">
          Search Flights
        </button>
      </div>

      {/* Table Section */}
      <div className="mt-6 overflow-x-auto">
        <table className="w-full border-collapse min-w-[900px]">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-3 border">Airline Name</th>
              <th className="p-3 border">From</th>
              <th className="p-3 border">To</th>
              <th className="p-3 border">No. of Seats</th>
              <th className="p-3 border">Cost</th>
              <th className="p-3 border">Month</th>
              <th className="p-3 border">On-ward Date</th>
              <th className="p-3 border">Return Date</th>
              <th className="p-3 border">Action</th>
            </tr>
          </thead>

          <tbody>
            {flightData.map((flight, index) => (
              <tr key={index} className="text-center">
                <td className="p-3 border">{flight.airline}</td>
                <td className="p-3 border">{flight.from}</td>
                <td className="p-3 border">{flight.to}</td>
                <td className="p-3 border">{flight.seats}</td>
                <td className="p-3 border">{flight.cost}</td>
                <td className="p-3 border">{flight.month}</td>
                <td className="p-3 border">{flight.onwarddate}</td>
                <td className="p-3 border">{flight.returndate}</td>

                <td className="p-3 border">
                  <button className="bg-blue-600 text-white px-4 py-1 rounded">
                    Enquiry Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RoundTrip;
